export const calculateAggregates = (item, tuition) => {
  const new_instAid =
    item.estEnrollment * tuition * (item.estTuitionDiscountRate / 100);
  return {
    group: item.group,
    estInstitutionalAid: new_instAid,
    estNetRevenue: item.estEnrollment * tuition - new_instAid,
    estEnrollment: item.estEnrollment,
    estTuitionDiscountRate: item.estTuitionDiscountRate,
  };
};

export const initialNonModeledData = {
  base: [],
  adjusted: [],
};

export function nonModeledReducer(state, action) {
  switch (action.type) {
    case "initialize": {
      return {
        ...state,
        base: action.exclusionGroups,
      };
    }

    case "update_adjusted": {
      // filter out groups that are not in the base data
      let adjustedExclusionGroups = action.exclusionGroups.filter((item) =>
        state.base.find((baseItem) => baseItem.group === item.group)
      );
      // add groups that are in the base data but not in the adjusted data
      state.base.forEach((item) => {
        if (!adjustedExclusionGroups.find((cur) => cur.group === item.group)) {
          adjustedExclusionGroups.push(item);
        }
      });
      return {
        ...state,
        adjusted: adjustedExclusionGroups,
      };
    }
    case "update_key": {
      return {
        ...state,
        adjusted: {
          ...state.adjusted,
          [action.key]: action.newValue,
        },
      };
    }
    case "update_group": {
      return {
        ...state,
        adjusted: state.adjusted.map((cur) => {
          if (cur.group === action.item.group) {
            return calculateAggregates(action.item, action.tuition);
          }
          return cur;
        }),
      };
    }
    case "reset_adjusted": {
      return {
        ...state,
        adjusted: state.base,
      };
    }
    case "reset_group": {
      const baseItem = state.base.find(
        (cur) => cur.group === action.item.group
      );
      return {
        ...state,
        adjusted: state.adjusted.map((cur) => {
          if (cur.group === action.item.group) {
            return baseItem;
          }
          return cur;
        }),
      };
    }

    default: {
      console.error("Unknown action: " + action.type);
      return state;
    }
  }
}
